import { useMutation } from "react-query";
import { axiosClient } from "../../../core/services/axiosInstance";

const useChangeProjectStatus = () => {
  const mutation = useMutation(({ projectId, status }) => {
    return axiosClient.post(
      `/Project/ChangeProjectStatus?projectId=${projectId}&status=${status}`
    );
  });
  return mutation;
};
export default useChangeProjectStatus;

